<template>
    <iframe :src="iframeSrc" id="mobsf" width="100%" height="100%" scrolling="no" frameborder="0"></iframe>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            dept: state => state.user.dept
        }),
        iframeSrc () {
          return `https://zgkd.zzrcfzjt.com/webroot/decision/view/report?viewlet=投简明细表.cpt`
        }
    }
}
</script>
